import type { ApiResponse, SendGetOptions, SendPostOptions, SendApiResponse, SendResponse } from '@/types/api';
import { api } from '@/utils/api';

/**
 * API 유틸함수 전역 설정
 */
export default defineNuxtPlugin(nuxtApp => {
  return {
    provide: {
      isSSR: api().isSSR(),
      sendGetInSetup: async (options: SendGetOptions): Promise<SendResponse> => {
        return await api().sendGetInSetup(options);
      },
      sendGet: async (options: SendGetOptions): Promise<SendApiResponse> => {
        return await api().sendGet(options);
      },
      sendPostInSetup: async (options: SendPostOptions): Promise<SendResponse> => {
        return await api().sendPostInSetup(options);
      },
      sendPost: async (options: SendPostOptions): Promise<SendApiResponse> => {
        return await api().sendPost(options);
      },
      getAccessToken: async (): Promise<ApiResponse | null> => {
        return await api().getAccessToken();
      },
    },
  }
});

declare module '#app' {
  interface NuxtApp {
    $isSSR: boolean;
    $sendGetInSetup: (options: SendGetOptions) => Promise<SendResponse>;
    $sendGet: (options: SendGetOptions) => Promise<SendApiResponse>;
    $sendPostInSetup: (options: SendPostOptions) => Promise<SendResponse>;
    $sendPost: (options: SendPostOptions) => Promise<SendApiResponse>;
    $getAccessToken: () => Promise<ApiResponse | null>;
  }
}